import { Create, Edit, List } from "../Components/index.js";

export default [
    {
        path: "/admin/setting/purchase-committee",
        component: List,
        name: "admin.purchase.committee",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/purchase-committee/create",
        component: Create,
        name: "admin.purchase.committee.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/purchase-committee/:id/edit",
        component: Edit,
        name: "admin.purchase.committee.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
